import { useState } from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import { api } from "../lib/api";
import { StyleTag } from "./Signup";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", {
        email,
        origin_url: window.location.origin,
      });
      setDevLink(data.dev_reset_link || "");
      setSent(true);
    } catch (err) {
      setSent(true); // never reveal whether the email exists
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F7F6]">
      <Nav />
      <div className="max-w-md mx-auto px-6 py-12">
        <h1 className="font-display text-4xl text-slate-800">Forgot your password?</h1>
        <p className="text-slate-600 mt-2">No stress. Pop your email in and we'll send a reset link.</p>

        {!sent ? (
          <form onSubmit={submit} className="mt-8 bg-white rounded-3xl p-8 border border-slate-100 shadow-sm space-y-5">
            <label className="block">
              <span className="uppercase tracking-[0.15em] text-xs font-semibold text-slate-500">Email</span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input zaf-focus mt-2"
                data-testid="forgot-email-input"
              />
            </label>
            <button
              data-testid="forgot-submit"
              disabled={loading}
              className="w-full bg-[#2E9D96] hover:bg-[#1F7B75] disabled:opacity-60 text-white font-semibold rounded-full py-3 transition-colors"
            >
              {loading ? "Sending…" : "Send reset link"}
            </button>
            <p className="text-sm text-slate-500 text-center">
              Remembered it? <Link to="/login" className="text-[#2E9D96] font-semibold">Back to login</Link>
            </p>
          </form>
        ) : (
          <div className="mt-8 bg-white rounded-3xl p-8 border border-slate-100 shadow-sm text-center" data-testid="forgot-sent">
            <MailCheck className="mx-auto text-[#2E9D96]" size={40} />
            <h2 className="font-display text-2xl text-slate-800 mt-4">Check your inbox.</h2>
            <p className="text-slate-600 mt-2">
              If that email is registered, a reset link is on its way. It's good for one hour.
            </p>
            {devLink && (
              <div className="mt-5 text-left">
                <p className="text-xs uppercase tracking-[0.15em] font-semibold text-slate-400">Dev mode — email not sending yet</p>
                <a href={devLink} className="text-sm text-[#2E9D96] font-semibold break-all hover:underline" data-testid="forgot-dev-link">
                  {devLink}
                </a>
              </div>
            )}
            <Link to="/login" className="inline-block mt-6 text-[#2E9D96] font-semibold">Back to login</Link>
          </div>
        )}
      </div>
      <StyleTag />
    </div>
  );
}
